import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function Home() {
  return (
    <div id="top">
      <div id="wrapper">
        <Header />
        <div id="navig">
          <Navigation />
        </div>
        <table id="Table_01" width="1000" height="900" border="0" cellPadding="0" cellSpacing="0" style={{ margin: '0 auto' }}>
        <tbody>
          <tr>
            <td colSpan="2">
              <img src="/images/index_03.png" width="1000" height="270" alt="" />
            </td>
            <td>
              <img src="/images/spacer.gif" width="1" height="270" alt="" />
            </td>
          </tr>
          <tr>
            <td width="714" rowSpan="2" bgcolor="#FFFFFF">
              <div id="intro_text">
                <div id="Welcome_text">
                  <p className="welcome_heading">Welcome to Indira Shiva Rao Polytechnic</p>
                  Indira Shiva Rao Polytechnic is an institution run by <strong>Sri Krishna Shikshana Prathisthana Trust, Sri Krishnapura Mutt</strong>, Car Street, Udupi, Under the able guidance of Sri Sri Vidyasagara Theertha Swamiji, who is the <strong>President</strong> of the <strong>Trust</strong>.
                  <p>The polytechnic started functioning in the year 1997 as the first and only Private Women's Polytechnic in the entire undivided Dakshina Kannada district. Due to popular demand from the parents for admission of boys, it was subsequently converted into a co-ed polytechnic in the year 1999.</p>
                </div>
              </div>
            </td>
            <td width="286">
              <div id="sidebar">
                <div id="sidebar_content">
                  <span className="Side_heads">Mission:</span><br /> To work with utmost will and determination for achieving overall personality development and intellectual growth of the students with effective deployment and management of best educational &amp; infrastructural facilities.
                  <p><span className="Side_heads">Vision:</span><br /> To establish an excellent, integrated campus for technical education in Udupi district.</p>
                </div>
              </div>
            </td>
            <td>
              <img src="/images/spacer.gif" width="1" height="205" alt="" />
            </td>
          </tr>
          <tr>
            <td rowSpan="2" bgcolor="#FFFFFF">
              <div id="sidebar2" className=" cources">
                <p className="Course2">The college offers the following courses:</p>
                <ul>
                  <li className="Crc_lnk"><Link to="/computer-science">Computer Science &amp; Engineering</Link></li>
                  <li className="Crc_lnk"><Link to="/electronics-engineering">Electronics &amp; Communication Engineering</Link></li>
                  <li className="Crc_lnk"><Link to="/mechanical-engineering">Mechanical Engineering</Link><Link to="/apparel-design"><br />
                    &nbsp; Apparel Design &amp; Fabrication Technology</Link></li>
                </ul>
                <div style={{ marginLeft: '30px' }}>
                  <center>
                    <Link to="/anti-ragging"><img src="/images/rag.png" width="128" height="135" alt="Anti Ragging" /></Link><br />For Anti-Ragging Committee list <Link className="inlinks" to="/anti-ragging">click here</Link>
                  </center>
                </div>
              </div>
            </td>
            <td>
              <img src="/images/spacer.gif" width="1" height="38" alt="" />
            </td>
          </tr>
          <tr>
            <td>
              <div id="intro_recogn">
                <div id="Recog_text">
                  <div id="recog1_text">
                    <div style={{ textAlign: 'left' }}><strong>RECOGNITION</strong> : Indira Shiva Rao Polytechnic offers Engineering Diploma course of 3 years (6 Semesters) duration, which has been recognized by All India Council for Technical Education (<a href="http://www.aicte-india.org/" target="_blank" rel="noopener noreferrer" className="inlinks">AICTE</a>), New Delhi and the institute is affiliated to <strong>Directorate of Technical Education</strong> (<a href="http://dtek.karnataka.gov.in/" target="_blank" rel="noopener noreferrer" className="inlinks">DTE</a>), Bengaluru.
                      <br />
                      .</div>
                    <p style={{ textAlign: 'left' }}><br />
                      The Board of Technical Examinations (BTE), Bengaluru under <strong>Directorate of Technical Education</strong> (<a href="http://dtek.karnataka.gov.in/" target="_blank" rel="noopener noreferrer" className="inlinks">DTE</a>), Govt. of Karnataka conducts all the exams and issues Diploma certificates at the end of the course.</p>
                    <ul style={{ listStyleImage: 'none', listStyleType: 'none', listStyle: 'none' }}>
                      <li></li>
                    </ul>
                    <ul style={{ listStyleImage: 'none', listStyleType: 'none', listStyle: 'none' }}>
                      <li><br />
                        <br />
                        <strong>FOR GRIEVANCE CELL <Link to="/grievance" className="inlinks">CLICK HERE<br />
                        </Link></strong> <strong><br />
                          FOR Mandatory Disclosure<a href="/Mandatory Disclosure 2023-24.pdf" target="new" className="inlinks"> CLICK HERE</a></strong></li>
                    </ul>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <img src="/images/spacer.gif" width="1" height="165" alt="" />
            </td>
          </tr>
          <tr>
            <td colSpan="2">
              <Footer />
            </td>
            <td>
              <img src="/images/spacer.gif" width="1" height="37" alt="" />
            </td>
          </tr>
        </tbody>
      </table>
      <Footer />
      </div>
    </div>
  );
}

export default Home;
